import React, { useEffect, useState } from 'react';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import HappyScreen from './happy';
import CategoriesScreen from './categories';
import HappyHourScreen from './happyHour';
import ExecutivemenuScreen from './executiveMenu';
import BarScreen from './bar';
import DetailProduct from './DetailProduct';
import { useSelector } from 'react-redux';

function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);
     const [dataDish, setDataDish] = useState(false);
     const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
      const [showHappyHour, setshowHappyHour] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showHappy, setShowHappy] = useState(false);
    const [showExecutiveMenu, SetshowExecutiveMenu] = useState(false);
    const [showBar, setShowBar] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [dataFood, setDataFood] = useState(false);
    const [steak, setSteak] = useState(false);
    const [tomahawk, settomahawk] = useState(false);
     const [drinks, setdrinks] = useState(false);
    const [datachicha, setdatachicha] = useState(false);
      const [saltados, setsaltados] = useState(false);
    const [dataLomo, setdataLomo] = useState(false);
    const [dataChaufa, setdataChaufa] = useState(false);

         const {
           goHomeInit
         } = useSelector((state) => state.initLoad);
        
    
        
    

    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);


    useEffect(() => {
    if (saltados) {
      saltados.map((item) => {
        if (item.id === 857) {
          setdataLomo(item);
        }
      });
    }
  }, [saltados]);


      useEffect(() => {
            menus.map((item) => {
                if (item.id === 102) {
                    setdrinks(item.menus);
                }
                if (item.id === 92) {
                    setsaltados(item.menus);
                }
                if (item.id === 100) {
                    setdataChaufa(item);
                }
            });
      }, [menus]);
    
    useEffect(() => {
    if (drinks) {
      drinks.map((item) => {
        if (item.id === 920) {
          setdatachicha(item);
        }
      });
    }
  }, [drinks]);
    
    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowListProduct(false);
            setShowSpecials(false)
            setShowHappy(false)
            setshowHappyHour(false)
            SetshowExecutiveMenu(false)
            setShowBar(false)
            setshowCategories(false)
            setShowDetailProduct(false)

            getInitData()
        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);


      useEffect(() => {
     
                setShowListProduct(false);
            setShowSpecials(false)
            setShowHappy(false)
            setshowHappyHour(false)
            SetshowExecutiveMenu(false)
            setShowBar(false)
            setshowCategories(false)
            setShowDetailProduct(false)
         }, [goHomeInit]);

    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };

        
    

    return (
          <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
        <LayoutContent showBack={false} showImageTop={true} setShowSpecials={setShowSpecials} goCategories={setshowCategories}>
                <div>

                <div style={{ width: '100%' }}>
                    <img
                        style={{
                            width: 390,
                            height: 110,
                            justifyContent: 'center',
                            objectFit: 'contain',
                            zIndex: 100,
                            alignSelf: 'center',
                                marginTop: -35,
                             pointerEvents: 'none',
                            
                        }}
                        src={require('./assets/66c8c19532843.jpg')}
                    />
                    </div>
                    <div style={{ width: '100%', position: 'relative', zIndex: 100, paddingInline: 20, boxSizing: 'border-box' }}>
                         <div style={{width: '100%'}}>
                            <div
                                 onClick={() => {
                                    setShowDetailProduct(true)
                                    setDataDish({ dish: dataLomo, alldish: saltados, currentDish: dataLomo })
                                }}>
                                    <video
                                        loop autoPlay={true} muted
                                        src={require('./assets/banner.mp4')}
                                        style={{
                                            width: '100%',
                                            height: 220,
                                            borderRadius: 14,
                                            objectFit: 'cover'
                                        }}
                                    />
                                </div>
                            </div>
                    </div>    
                <div style={{ display: 'flex', marginTop: 3,width: '100%',  gap: 20,position: 'relative', zIndex: 100,  paddingInline: 20, boxSizing: 'border-box' }}>
                    <div style={{ width: '50%' }} >
                            <video
                               onClick={() => {
                                    setdishs(dataChaufa)
                                    setShowListProduct(true)
                                }}
                            src={require('./assets/chaufa.mp4')}
                            loop autoPlay={true} muted 
                            style={{
                                marginTop: 1,
                                width: '100%',
                                height: 240,
               
                                objectFit: 'cover',
                                borderRadius: 14,
                               
                               
                            }}
                        />
                    </div>

                     <div style={{ width: '50%'}}  onClick={() => {
                                    setShowDetailProduct(true)
                                    setDataDish({ dish: datachicha, alldish: drinks, currentDish: datachicha })
                                }}>
                            <img
                                 
                            src={require('./assets/rghjfg.png')}
                            loop autoPlay={true} muted 
                            style={{
                                marginTop: 1,
                               width: '100%',
                                height: 240,
                                objectFit: 'cover',
                                borderRadius: 14,
                                 pointerEvents: 'none',
                               
                               
                            }}
                        />

                    </div>
                </div>
               
            </div>

            <div
                    onClick={() => {
                         setshowCategories(true)
                    }}
                    
                style={{
                    width: '100%',
                    alignItems: 'center',
                    paddingInline: 20,
                    boxSizing: 'border-box',
                    marginTop: 10,
                    
                }}>
                    <img
                         onContextMenu={(e) => e.preventDefault()}
                    src={require('./assets/tap.png')}
                    style={{
                        width: '100%',
                        height: 280,
                        objectFit: 'contain',
                        borderRadius: 15,
                        marginTop: -10,
                        pointerEvents: 'none',
                        
                        
                        
                    }}
                />
            </div>

            {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}
            
            {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} />}
                {showHappyHour && <HappyScreen setShowListProduct={setshowHappyHour} />}
            {showHappy && <HappyHourScreen setShowHappy={setShowHappy} />}
            {showExecutiveMenu && <ExecutivemenuScreen SetshowExecutiveMenu={SetshowExecutiveMenu} />}
                {showBar && <BarScreen setShowBar={setShowBar} />}
                
                 {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={()=>setShowDetailProduct(false)}
                    setShowDetailProduct={setShowDetailProduct}
                />}
                

            </LayoutContent>
            </div>
    );
}

export default Index;